export const environment = {
  production: false,
  apiUrl: 'https://api.test.partner-portal.iowaortho.com/api',
  tokenAuthority: 'https://???/', //TODO: Needs updated
  ioOrthoUrl: "https://www.iowaortho.com",
  privacyPolicyUrl: "https://iowaortho.com/wp-content/uploads/2025/05/Notice-of-Privacy-Practices.pdf",
  termsOfUseUrl: "https://www.iowaortho.com/notice-of-privacy-practices/",
  cognitoUserPoolId: 'us-east-2_bdH19pIDO',
  cognitoAppClientId: '1ea43sckchor01rbnf7r00vpj0',
  cognitoTotpIssuer: 'Iowa Ortho Partner Portal Test',
  impersonateAllowed: true,
  reusableComponentFeedUrl: 'https://iowaortho.spinuhost.com/wp-json/iowa-ortho/v1/chrome'
};
